export const Loading = () => {
    return (
        <div className="loader-container">
            <div className="loader"></div>
        </div>
    )
}
